export const Copyright = () => <span>Copyright © {(new Date()).getFullYear()} Xappex.</span>